<template>
  <v-app>  
    <v-container>
      
        <v-card flat>
          <v-tabs v-if="perfil === 'medico'" v-model="tab" color="primary">
            <v-tab>Todos los pacientes</v-tab>
            <v-tab>Mis pacientes</v-tab>
          </v-tabs>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar por DNI, nombre o apellido"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>               
                    
                        <v-data-table 
                          :headers="headers"
                          :items="tableData"
                          :loading="loading"
                          :server-items-length="totalRows"
                          :options.sync="options"
                          :items-per-page="options.itemsPerPage"
                          :page.sync="options.page"
                          @update:options="fetchData"
                          @click:row="irAVistaDetallada($event)"
                          :search="search"
                          :no-data-text="noDataText"
                          class="elevation-1">
                          <template v-slot:item.party.ref="{ item }">
                            {{ (item.party && item.party.ref) ? item.party.ref : (item.ref || '') }}
                          </template>
                          <template v-slot:item.party.name="{ item }">
                            {{ (item.party && item.party.name) ? item.party.name : (item.name || '') }}
                          </template>
                          <template v-slot:item.party.lastname="{ item }">
                            {{ (item.party && item.party.lastname) ? item.party.lastname : (item.lastname || '') }}
                          </template>
                          <template v-slot:item.seguro.empresa.name="{ item }">
                            {{ (item.seguro && item.seguro.empresa && item.seguro.empresa.name) ? item.seguro.empresa.name : ((item.seguro && item.seguro.empresa) ? item.seguro.empresa : '') }}
                          </template>
                        </v-data-table>
                
                    
        </v-card>
     
    </v-container>
  </v-app> 
</template>

<script>

import axios from 'axios';
import { getPacienteUnificado } from '@/services/monolito';
import pacienteMixin from '@/mixins/pacienteMixin';

export default {
  name: "Paciente",
  mixins: [pacienteMixin],
  created() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    if (this.$route.query.tab === 'mis') {
      this.tab = 1;
    }
  },
  computed: {
    misPacientes() {
      return this.perfil === 'medico' && this.tab === 1;
    },
    noDataText() {
      return this.misPacientes
        ? 'Todavía no registraste consultas con ningún paciente'
        : 'No se encontraron pacientes';
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    },
    search(newVal) {
      // Sync URL with search term
      if (newVal !== this.$route.query.search) {
        this.$router.replace({ 
            query: { 
                ...this.$route.query, 
                search: newVal || undefined 
            } 
        }).catch(err => {
            // Ignore DuplicateNavigation error if it happens
            if (err.name !== 'NavigationDuplicated') {
                throw err;
            }
        });
      }
      this.options.page = 1; 
      this.fetchData();
    },
    tab(newVal) {
      const tab = newVal === 1 ? 'mis' : undefined;
      if (tab !== this.$route.query.tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
      this.options.page = 1;
      this.fetchData();
    }
  },
  // Data
  data() {
    return {
      search: '',
      tab: 0,
      perfil: 'secretaria',
      headers: [
        {text: 'Id', align: 'left', sorteable: false, value: 'id'},
        {text: 'DNI', align: 'left', sorteable: false, value: 'party.ref'},
        {text: 'Nombre', align: 'left', sorteable: false, value: 'party.name'},
        {text: 'Apellido', align: 'left', sorteable: true, value: 'party.lastname'},
        {text: 'Obra Social', align: 'left', sorteable: false, value: 'seguro.empresa.name'},
      ],
      pacientes: [],
      loading: false,
      tableData: [],
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      totalRows: 0,
      //end table
      // local variables not to be passed

      dialog: false,
      jsonHorario: []

    }
  },

  mounted() {
    this.perfil = this.$route.query.perfil;
    this.fetchData();
  },

  beforeDestroy() {
    //this.removeRecaptcha()
  },

  // Using Axios

  methods: {
    irAVistaDetallada(paciente) {
      if (this.perfil === 'secretaria') {
        this.$router.push({name: 'paciente-detalle', params: {idPaciente: paciente.id}});
      }
      else if (this.perfil === 'medico') {
        this.$router.push({name: 'historia-clinica', params: {idPaciente: paciente.id}});
      }
    },
    async fetchData() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;

      try {
        // Usar el nuevo sistema unificado para paginación
        // null indica que no estamos buscando por ID/DNI específico, sino listado (o búsqueda general)
        const resultado = await getPacienteUnificado(null, {
          page: page,
          per_page: itemsPerPage,
          search: this.search,
          sort_by: this.options.sortBy[0],
          sort_desc: this.options.sortDesc[0],
          // Solo pacientes con consultas del médico logueado
          mine: this.misPacientes ? true : undefined,
        });
        
        if (resultado.success) {
          // Manejar la respuesta según la estructura del backend

          
          if (resultado.data && Array.isArray(resultado.data.data)) {
            // Si el backend devuelve { data: [...], total: number } y data.data es array
            this.tableData = resultado.data.data;
            this.totalRows = resultado.data.total || 0;
          } else if (Array.isArray(resultado.data)) {
            // Si el backend devuelve directamente un array
            this.tableData = resultado.data;
            this.totalRows = resultado.data.length;
          } else {
             // Fallback para objetos no array: envolver en array si es un objeto válido, sino array vacío
             console.warn('⚠️ PacienteList: Estructura de datos no reconocida, forzando array');
             if (resultado.data && typeof resultado.data === 'object') {
                 this.tableData = [resultado.data];
                 this.totalRows = 1;
             } else {
                 this.tableData = [];
                 this.totalRows = 0;
             }
          }
        } else {
          console.error('Error en fetchData:', resultado.error);
          this.tableData = [];
          this.totalRows = 0;
        }
      } catch (error) {
        console.error('Error en fetchData:', error);
        
        // Mostrar mensaje de error específico
        if (error.message.includes('CORS')) {
          this.$alert({
            title: 'Error de CORS',
            message: 'El servidor monolito no permite requests desde este origen. Contactar al administrador.',
            color: 'error'
          })
        } else if (error.message.includes('conexión')) {
          this.$alert({
            title: 'Error de conexión',
            message: 'No se puede conectar al servidor monolito. Verificar que esté corriendo.',
            color: 'error'
          })
        } else if (error.message.includes('405')) {
          this.$alert({
            title: 'Error 405',
            message: 'El endpoint no está configurado correctamente. Verificar /paciente_list para paginación.',
            color: 'error'
          })
        } else {
          this.$alert({
            title: 'Error',
            message: 'Error al cargar la lista de pacientes: ' + error.message,
            color: 'error'
          })
        }
        
        // Limpiar datos en caso de error
        this.tableData = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    }
    }
}

</script>

<style>

  #nota{
    font-size: 80%;
    color: #dc3545;
  }
  .style-select .vs__search::placeholder,
  .style-select .vs__search,
  .style-select .vs__dropdown-menu {
    border: none;
    text-transform: lowercase;
    font-variant: small-caps;
  }
  .vs__fade-enter-active,
  .vs__fade-leave-active {
        transition: none;
    }
  .invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    }
</style>
